import React from 'react'

let serverHost: string
let serviceName: string
let loginText1: string
let loginText2: string
let micenavi_whats_new: string
let enableNotificationArticlePush: string
let enableUsersCsvDownload: string
let enableUsersSearchKatudouStatus: string
let enableUsersSearchMessageCount: string
let enableUsersSearchNote: string
let enableUsersFilterKatudouStatus: string
let enableUsersFilterProfileImg: string
let enableUsersFilterChangeCount: string
let enableUsersFilterResetRestrictionLog: string
let enableUsersFilterMessageCount: string
let enableUsersFilterNote: string
let enableUsersFilterReset: string
let enableMessagesSearchMessageCount: string
let enableMessagesFilterMessageCount: string
let enableMessagesFilterUnread: string
let enableMessagesFilterUserUnread: string
let enableMessagesFilterReset: string
let enableEventsFilterSender: string
let enableEventsFilterCloseFlg: string
let enableEventsFilterPost: string
let enableEventsFilterProgress: string
let enableEventsFilterReset: string
let enableNotificationsFilterSender: string
let enableNotificationsFilterCategory: string
let enableNotificationsFilterImportantFlg: string
let enableNotificationsFilterHotNewsFlg: string
let enableNotificationsFilterCloseFlg: string
let enableNotificationsFilterPost: string
let enableNotificationsFilterPush: string
let enableNotificationsFilterReset: string
let enableNotificationsMemberSiteFlg: string
let enableBannerPreview: string
let enableBannerMemberFlg: string
let enableBannerMemberSiteFlg: string

switch (process.env.REACT_APP_NODE_ENV) {
  case 'local':
    serverHost = process.env.REACT_APP_LOCAL_API_URL
    serviceName = process.env.REACT_APP_LOCAL_SERVICE_NAME
    loginText1 = process.env.REACT_APP_LOCAL_LOGIN_1
    loginText2 = process.env.REACT_APP_LOCAL_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_LOCAL_MICENAVI_WHATS_NEW
    enableNotificationArticlePush = process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATION_ARTICLE_PUSH
    enableUsersCsvDownload = process.env.REACT_APP_LOCAL_ENABLE_ENABLE_USERS_CSV_DOWNLOAD
    enableUsersSearchKatudouStatus = process.env.REACT_APP_LOCAL_ENABLE_USERS_SEARCH_KATUDOU_STATUS
    enableUsersSearchMessageCount = process.env.REACT_APP_LOCAL_ENABLE_USERS_SEARCH_MESSAGE_COUNT
    enableUsersSearchNote = process.env.REACT_APP_LOCAL_ENABLE_USERS_SEARCH_NOTE
    enableUsersFilterKatudouStatus = process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_KATUDOU_STATUS
    enableUsersFilterProfileImg = process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_PROFILE_IMG
    enableUsersFilterChangeCount = process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_CHANGE_COUNT
    enableUsersFilterResetRestrictionLog =
      process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_RESET_RESTRICTION_LOG
    enableUsersFilterMessageCount = process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_MESSAGE_COUNT
    enableUsersFilterNote = process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_NOTE
    enableUsersFilterReset = process.env.REACT_APP_LOCAL_ENABLE_USERS_FILTER_RESET
    enableMessagesSearchMessageCount =
      process.env.REACT_APP_LOCAL_ENABLE_MESSAGES_SEARCH_MESSAGE_COUNT
    enableMessagesFilterMessageCount =
      process.env.REACT_APP_LOCAL_ENABLE_MESSAGES_FILTER_MESSAGE_COUNT
    enableMessagesFilterUnread = process.env.REACT_APP_LOCAL_ENABLE_MESSAGES_FILTER_UNREAD
    enableMessagesFilterUserUnread = process.env.REACT_APP_LOCAL_ENABLE_MESSAGES_FILTER_USER_UNREAD
    enableMessagesFilterReset = process.env.REACT_APP_LOCAL_ENABLE_MESSAGES_FILTER_RESET
    enableEventsFilterSender = process.env.REACT_APP_LOCAL_ENABLE_EVENTS_FILTER_SENDER
    enableEventsFilterCloseFlg = process.env.REACT_APP_LOCAL_ENABLE_EVENTS_FILTER_CLOSE_FLG
    enableEventsFilterPost = process.env.REACT_APP_LOCAL_ENABLE_EVENTS_FILTER_POST
    enableEventsFilterProgress = process.env.REACT_APP_LOCAL_ENABLE_EVENTS_FILTER_PROGRESS
    enableEventsFilterReset = process.env.REACT_APP_LOCAL_ENABLE_EVENTS_FILTER_RESET
    enableNotificationsFilterSender = process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_SENDER
    enableNotificationsFilterCategory =
      process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_CATEGORY
    enableNotificationsFilterImportantFlg =
      process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_IMPORTANT_FLG
    enableNotificationsFilterHotNewsFlg =
      process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_HOT_NEWS_FLG
    enableNotificationsFilterCloseFlg =
      process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_CLOSE_FLG
    enableNotificationsFilterPost = process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_POST
    enableNotificationsFilterPush = process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_PUSH
    enableNotificationsFilterReset = process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_FILTER_RESET
    enableNotificationsMemberSiteFlg =
      process.env.REACT_APP_LOCAL_ENABLE_NOTIFICATIONS_MEMBER_SITE_FLG
    enableBannerPreview = process.env.REACT_APP_LOCAL_ENABLE_BANNER_PREVIEW
    enableBannerMemberFlg = process.env.REACT_APP_LOCAL_ENABLE_BANNER_MEMBER_FLG
    enableBannerMemberSiteFlg = process.env.REACT_APP_LOCAL_ENABLE_BANNER_MEMBER_SITE_FLG
    break
  case 'development':
    serverHost = process.env.REACT_APP_DEV_API_URL
    serviceName = process.env.REACT_APP_DEV_SERVICE_NAME
    loginText1 = process.env.REACT_APP_DEV_LOGIN_1
    loginText2 = process.env.REACT_APP_DEV_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_DEV_MICENAVI_WHATS_NEW
    enableNotificationArticlePush = process.env.REACT_APP_DEV_ENABLE_NOTIFICATION_ARTICLE_PUSH
    enableUsersCsvDownload = process.env.REACT_APP_DEV_ENABLE_ENABLE_USERS_CSV_DOWNLOAD
    enableUsersSearchKatudouStatus = process.env.REACT_APP_DEV_ENABLE_USERS_SEARCH_KATUDOU_STATUS
    enableUsersSearchMessageCount = process.env.REACT_APP_DEV_ENABLE_USERS_SEARCH_MESSAGE_COUNT
    enableUsersSearchNote = process.env.REACT_APP_DEV_ENABLE_USERS_SEARCH_NOTE
    enableUsersFilterKatudouStatus = process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_KATUDOU_STATUS
    enableUsersFilterProfileImg = process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_PROFILE_IMG
    enableUsersFilterChangeCount = process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_CHANGE_COUNT
    enableUsersFilterResetRestrictionLog =
      process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_RESET_RESTRICTION_LOG
    enableUsersFilterMessageCount = process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_MESSAGE_COUNT
    enableUsersFilterNote = process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_NOTE
    enableUsersFilterReset = process.env.REACT_APP_DEV_ENABLE_USERS_FILTER_RESET
    enableMessagesSearchMessageCount =
      process.env.REACT_APP_DEV_ENABLE_MESSAGES_SEARCH_MESSAGE_COUNT
    enableMessagesFilterMessageCount =
      process.env.REACT_APP_DEV_ENABLE_MESSAGES_FILTER_MESSAGE_COUNT
    enableMessagesFilterUnread = process.env.REACT_APP_DEV_ENABLE_MESSAGES_FILTER_UNREAD
    enableMessagesFilterUserUnread = process.env.REACT_APP_DEV_ENABLE_MESSAGES_FILTER_USER_UNREAD
    enableMessagesFilterReset = process.env.REACT_APP_DEV_ENABLE_MESSAGES_FILTER_RESET
    enableEventsFilterSender = process.env.REACT_APP_DEV_ENABLE_EVENTS_FILTER_SENDER
    enableEventsFilterCloseFlg = process.env.REACT_APP_DEV_ENABLE_EVENTS_FILTER_CLOSE_FLG
    enableEventsFilterPost = process.env.REACT_APP_DEV_ENABLE_EVENTS_FILTER_POST
    enableEventsFilterProgress = process.env.REACT_APP_DEV_ENABLE_EVENTS_FILTER_PROGRESS
    enableEventsFilterReset = process.env.REACT_APP_DEV_ENABLE_EVENTS_FILTER_RESET
    enableNotificationsFilterSender = process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_SENDER
    enableNotificationsFilterCategory =
      process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_CATEGORY
    enableNotificationsFilterImportantFlg =
      process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_IMPORTANT_FLG
    enableNotificationsFilterHotNewsFlg =
      process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_HOT_NEWS_FLG
    enableNotificationsFilterCloseFlg =
      process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_CLOSE_FLG
    enableNotificationsFilterPost = process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_POST
    enableNotificationsFilterPush = process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_PUSH
    enableNotificationsFilterReset = process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_FILTER_RESET
    enableNotificationsMemberSiteFlg =
      process.env.REACT_APP_DEV_ENABLE_NOTIFICATIONS_MEMBER_SITE_FLG
    enableBannerPreview = process.env.REACT_APP_DEV_ENABLE_BANNER_PREVIEW
    enableBannerMemberFlg = process.env.REACT_APP_DEV_ENABLE_BANNER_MEMBER_FLG
    enableBannerMemberSiteFlg = process.env.REACT_APP_DEV_ENABLE_BANNER_MEMBER_SITE_FLG
    break
  case 'base':
    serverHost = process.env.REACT_APP_BASE_API_URL
    serviceName = process.env.REACT_APP_BASE_SERVICE_NAME
    loginText1 = process.env.REACT_APP_BASE_LOGIN_1
    loginText2 = process.env.REACT_APP_BASE_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_BASE_MICENAVI_WHATS_NEW
    enableNotificationArticlePush = process.env.REACT_APP_BASE_ENABLE_NOTIFICATION_ARTICLE_PUSH
    enableUsersCsvDownload = process.env.REACT_APP_BASE_ENABLE_ENABLE_USERS_CSV_DOWNLOAD
    enableUsersSearchKatudouStatus = process.env.REACT_APP_BASE_ENABLE_USERS_SEARCH_KATUDOU_STATUS
    enableUsersSearchMessageCount = process.env.REACT_APP_BASE_ENABLE_USERS_SEARCH_MESSAGE_COUNT
    enableUsersSearchNote = process.env.REACT_APP_BASE_ENABLE_USERS_SEARCH_NOTE
    enableUsersFilterKatudouStatus = process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_KATUDOU_STATUS
    enableUsersFilterProfileImg = process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_PROFILE_IMG
    enableUsersFilterChangeCount = process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_CHANGE_COUNT
    enableUsersFilterResetRestrictionLog =
      process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_RESET_RESTRICTION_LOG
    enableUsersFilterMessageCount = process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_MESSAGE_COUNT
    enableUsersFilterNote = process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_NOTE
    enableUsersFilterReset = process.env.REACT_APP_BASE_ENABLE_USERS_FILTER_RESET
    enableMessagesSearchMessageCount =
      process.env.REACT_APP_BASE_ENABLE_MESSAGES_SEARCH_MESSAGE_COUNT
    enableMessagesFilterMessageCount =
      process.env.REACT_APP_BASE_ENABLE_MESSAGES_FILTER_MESSAGE_COUNT
    enableMessagesFilterUnread = process.env.REACT_APP_BASE_ENABLE_MESSAGES_FILTER_UNREAD
    enableMessagesFilterUserUnread = process.env.REACT_APP_BASE_ENABLE_MESSAGES_FILTER_USER_UNREAD
    enableMessagesFilterReset = process.env.REACT_APP_BASE_ENABLE_MESSAGES_FILTER_RESET
    enableEventsFilterSender = process.env.REACT_APP_BASE_ENABLE_EVENTS_FILTER_SENDER
    enableEventsFilterCloseFlg = process.env.REACT_APP_BASE_ENABLE_EVENTS_FILTER_CLOSE_FLG
    enableEventsFilterPost = process.env.REACT_APP_BASE_ENABLE_EVENTS_FILTER_POST
    enableEventsFilterProgress = process.env.REACT_APP_BASE_ENABLE_EVENTS_FILTER_PROGRESS
    enableEventsFilterReset = process.env.REACT_APP_BASE_ENABLE_EVENTS_FILTER_RESET
    enableNotificationsFilterSender = process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_SENDER
    enableNotificationsFilterCategory =
      process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_CATEGORY
    enableNotificationsFilterImportantFlg =
      process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_IMPORTANT_FLG
    enableNotificationsFilterHotNewsFlg =
      process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_HOT_NEWS_FLG
    enableNotificationsFilterCloseFlg =
      process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_CLOSE_FLG
    enableNotificationsFilterPost = process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_POST
    enableNotificationsFilterPush = process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_PUSH
    enableNotificationsFilterReset = process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_FILTER_RESET
    enableNotificationsMemberSiteFlg =
      process.env.REACT_APP_BASE_ENABLE_NOTIFICATIONS_MEMBER_SITE_FLG
    enableBannerPreview = process.env.REACT_APP_BASE_ENABLE_BANNER_PREVIEW
    enableBannerMemberFlg = process.env.REACT_APP_BASE_ENABLE_BANNER_MEMBER_FLG
    enableBannerMemberSiteFlg = process.env.REACT_APP_BASE_ENABLE_BANNER_MEMBER_SITE_FLG
    break
  case 'staging':
    serverHost = process.env.REACT_APP_STAGING_API_URL
    serviceName = process.env.REACT_APP_STAGING_SERVICE_NAME
    loginText1 = process.env.REACT_APP_STAGING_LOGIN_1
    loginText2 = process.env.REACT_APP_STAGING_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_STAGING_MICENAVI_WHATS_NEW
    break
  case 'production':
    serverHost = process.env.REACT_APP_PROD_API_URL
    serviceName = process.env.REACT_APP_PROD_SERVICE_NAME
    loginText1 = process.env.REACT_APP_PROD_LOGIN_1
    loginText2 = process.env.REACT_APP_PROD_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_PROD_MICENAVI_WHATS_NEW
    break
  case 'test':
    serverHost = process.env.REACT_APP_TEST_API_URL
    serviceName = process.env.REACT_APP_TEST_SERVICE_NAME
    loginText1 = process.env.REACT_APP_TEST_LOGIN_1
    loginText2 = process.env.REACT_APP_TEST_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_TEST_MICENAVI_WHATS_NEW
    enableNotificationArticlePush = process.env.REACT_APP_TEST_ENABLE_NOTIFICATION_ARTICLE_PUSH
    enableUsersCsvDownload = process.env.REACT_APP_TEST_ENABLE_ENABLE_USERS_CSV_DOWNLOAD
    enableUsersSearchKatudouStatus = process.env.REACT_APP_TEST_ENABLE_USERS_SEARCH_KATUDOU_STATUS
    enableUsersSearchMessageCount = process.env.REACT_APP_TEST_ENABLE_USERS_SEARCH_MESSAGE_COUNT
    enableUsersSearchNote = process.env.REACT_APP_TEST_ENABLE_USERS_SEARCH_NOTE
    enableUsersFilterKatudouStatus = process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_KATUDOU_STATUS
    enableUsersFilterProfileImg = process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_PROFILE_IMG
    enableUsersFilterChangeCount = process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_CHANGE_COUNT
    enableUsersFilterResetRestrictionLog =
      process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_RESET_RESTRICTION_LOG
    enableUsersFilterMessageCount = process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_MESSAGE_COUNT
    enableUsersFilterNote = process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_NOTE
    enableUsersFilterReset = process.env.REACT_APP_TEST_ENABLE_USERS_FILTER_RESET
    enableMessagesSearchMessageCount =
      process.env.REACT_APP_TEST_ENABLE_MESSAGES_SEARCH_MESSAGE_COUNT
    enableMessagesFilterMessageCount =
      process.env.REACT_APP_TEST_ENABLE_MESSAGES_FILTER_MESSAGE_COUNT
    enableMessagesFilterUnread = process.env.REACT_APP_TEST_ENABLE_MESSAGES_FILTER_UNREAD
    enableMessagesFilterUserUnread = process.env.REACT_APP_TEST_ENABLE_MESSAGES_FILTER_USER_UNREAD
    enableMessagesFilterReset = process.env.REACT_APP_TEST_ENABLE_MESSAGES_FILTER_RESET
    enableEventsFilterSender = process.env.REACT_APP_TEST_ENABLE_EVENTS_FILTER_SENDER
    enableEventsFilterCloseFlg = process.env.REACT_APP_TEST_ENABLE_EVENTS_FILTER_CLOSE_FLG
    enableEventsFilterPost = process.env.REACT_APP_TEST_ENABLE_EVENTS_FILTER_POST
    enableEventsFilterProgress = process.env.REACT_APP_TEST_ENABLE_EVENTS_FILTER_PROGRESS
    enableEventsFilterReset = process.env.REACT_APP_TEST_ENABLE_EVENTS_FILTER_RESET
    enableNotificationsFilterSender = process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_SENDER
    enableNotificationsFilterCategory =
      process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_CATEGORY
    enableNotificationsFilterImportantFlg =
      process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_IMPORTANT_FLG
    enableNotificationsFilterHotNewsFlg =
      process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_HOT_NEWS_FLG
    enableNotificationsFilterCloseFlg =
      process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_CLOSE_FLG
    enableNotificationsFilterPost = process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_POST
    enableNotificationsFilterPush = process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_PUSH
    enableNotificationsFilterReset = process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_FILTER_RESET
    enableNotificationsMemberSiteFlg =
      process.env.REACT_APP_TEST_ENABLE_NOTIFICATIONS_MEMBER_SITE_FLG
    enableBannerPreview = process.env.REACT_APP_TEST_ENABLE_BANNER_PREVIEW
    enableBannerMemberFlg = process.env.REACT_APP_TEST_ENABLE_BANNER_MEMBER_FLG
    enableBannerMemberSiteFlg = process.env.REACT_APP_TEST_ENABLE_BANNER_MEMBER_SITE_FLG
    break
  default:
    serverHost = process.env.REACT_APP_BASE_API_URL
    serviceName = process.env.REACT_APP_BASE_SERVICE_NAME
    loginText1 = process.env.REACT_APP_BASE_LOGIN_1
    loginText2 = process.env.REACT_APP_BASE_LOGIN_2
    micenavi_whats_new = process.env.REACT_APP_BASE_MICENAVI_WHATS_NEW
    break
}

const ConfigContext = React.createContext({
  serverHost: serverHost,
  serviceName: serviceName,
  loginText1: loginText1,
  loginText2: loginText2,
  micenavi_whats_new: micenavi_whats_new,
  enableNotificationArticlePush: enableNotificationArticlePush,
  enableUsersCsvDownload: enableUsersCsvDownload,
  enableUsersSearchKatudouStatus: enableUsersSearchKatudouStatus,
  enableUsersSearchMessageCount: enableUsersSearchMessageCount,
  enableUsersSearchNote: enableUsersSearchNote,
  enableUsersFilterKatudouStatus: enableUsersFilterKatudouStatus,
  enableUsersFilterProfileImg: enableUsersFilterProfileImg,
  enableUsersFilterChangeCount: enableUsersFilterChangeCount,
  enableUsersFilterResetRestrictionLog: enableUsersFilterResetRestrictionLog,
  enableUsersFilterMessageCount: enableUsersFilterMessageCount,
  enableUsersFilterNote: enableUsersFilterNote,
  enableUsersFilterReset: enableUsersFilterReset,
  enableMessagesSearchMessageCount: enableMessagesSearchMessageCount,
  enableMessagesFilterMessageCount: enableMessagesFilterMessageCount,
  enableMessagesFilterUnread: enableMessagesFilterUnread,
  enableMessagesFilterUserUnread: enableMessagesFilterUserUnread,
  enableMessagesFilterReset: enableMessagesFilterReset,
  enableEventsFilterSender: enableEventsFilterSender,
  enableEventsFilterCloseFlg: enableEventsFilterCloseFlg,
  enableEventsFilterPost: enableEventsFilterPost,
  enableEventsFilterProgress: enableEventsFilterProgress,
  enableEventsFilterReset: enableEventsFilterReset,
  enableNotificationsFilterSender: enableNotificationsFilterSender,
  enableNotificationsFilterCategory: enableNotificationsFilterCategory,
  enableNotificationsFilterImportantFlg: enableNotificationsFilterImportantFlg,
  enableNotificationsFilterHotNewsFlg: enableNotificationsFilterHotNewsFlg,
  enableNotificationsFilterCloseFlg: enableNotificationsFilterCloseFlg,
  enableNotificationsFilterPost: enableNotificationsFilterPost,
  enableNotificationsFilterPush: enableNotificationsFilterPush,
  enableNotificationsFilterReset: enableNotificationsFilterReset,
  enableNotificationsMemberSiteFlg: enableNotificationsMemberSiteFlg,
  enableBannerPreview: enableBannerPreview,
  enableBannerMemberFlg: enableBannerMemberFlg,
  enableBannerMemberSiteFlg: enableBannerMemberSiteFlg
})

export const ConfigProvider = ConfigContext.Provider
export const ConfigConsumer = ConfigContext.Consumer
export default ConfigContext
